@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Purchase Requests</h1>
            @if(!isReadOnly) {
            <div class="action">
                <ppl-button label="Add New Purchase Request" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (click)="addNewPurchaseRequest()"
                    [authorizeButton]="[pageId, 'AddNewPurchaseRequest']"></ppl-button>
            </div>
            }
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-purchase-request-filters (searchEvent)="onSearch($event)" export="true" (exportEvent)="onExport($event)" [pageId]="pageId"></ppl-purchase-request-filters>
                </div>
                <div class="table-style w-100">
                    @if(purchaseRequests.length > 0) {
                    <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [enableActions]="true" [data]="purchaseRequests" [disableSelection]="true" [cols]="cols"
                        (gridAction)="onAction($event)" [gridTitle]="false" [pagination]="true" [loadPage]="true"
                        [badgeColumns]="['Status']"
                        [customDataLoaded]="true" [actionButtons]="actionButtons" [from]="'purchaseRequest'"
                        (onPageLoad)="onPageLoad($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> Atleast one out of the following fields should be populated: Participant Name, Participant PPL ID, Provider Name,
            Provider PPL ID</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #createPurchaseRequestDialog let-cancel="cancel">
        <ppl-create-purchase-request [mode]="mode" (purchaseRequestEvent)="handleCreatePurchaseRequest()"
            (cancel)="handleAddPurchaseRequestCancel($event)" [staffView]="true"></ppl-create-purchase-request>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #viewPurchaseRequestDialog let-cancel="cancel">
        <ppl-create-purchase-request [mode]="mode" [purchaseRequestListData]="viewPurchaseRequestData"
            (purchaseRequestEvent)="handleCreatePurchaseRequest()" (cancel)="handleAddPurchaseRequestCancel($event)"
            [staffView]="true"></ppl-create-purchase-request>
    </ng-template>
</div>
